import React from "react";

const ICON_ALIAS_MAP = {
  home: "fa-solid fa-house",
  "message-square": "fa-solid fa-comments",
  forum: "fa-solid fa-comments",
  forums: "fa-solid fa-comments",
  users: "fa-solid fa-users",
  members: "fa-solid fa-users",
  trophy: "fa-solid fa-trophy",
  crown: "fa-solid fa-crown",
  shield: "fa-solid fa-shield-halved",
  "shield-check": "fa-solid fa-shield-halved",
  server: "fa-solid fa-server",
  servers: "fa-solid fa-server",
  gamepad: "fa-solid fa-gamepad",
  swords: "fa-solid fa-burst",
  crosshair: "fa-solid fa-crosshairs",
  target: "fa-solid fa-bullseye",
  download: "fa-solid fa-download",
  downloads: "fa-solid fa-download",
  resurse: "fa-solid fa-download",
  clans: "fa-solid fa-shield-halved",
  "hard-drive": "fa-solid fa-hard-drive",
  gift: "fa-solid fa-gift",
  coins: "fa-solid fa-coins",
  wallet: "fa-solid fa-wallet",
  creditcard: "fa-solid fa-credit-card",
  "credit-card": "fa-solid fa-credit-card",
  heart: "fa-solid fa-heart",
  donate: "fa-solid fa-heart",
  sparkles: "fa-solid fa-wand-magic-sparkles",
  vip: "fa-solid fa-crown",
  newspaper: "fa-solid fa-newspaper",
  news: "fa-solid fa-newspaper",
  flame: "fa-solid fa-fire-flame-curved",
  zap: "fa-solid fa-bolt",
  bolt: "fa-solid fa-bolt",
  star: "fa-solid fa-star",
  user: "fa-solid fa-user",
  lock: "fa-solid fa-lock",
  unlock: "fa-solid fa-unlock",
  check: "fa-solid fa-circle-check",
  settings: "fa-solid fa-gear",
  search: "fa-solid fa-magnifying-glass",
  discord: "fa-brands fa-discord",
  steam: "fa-brands fa-steam",
  youtube: "fa-brands fa-youtube",
  twitch: "fa-brands fa-twitch",
  facebook: "fa-brands fa-facebook",
  instagram: "fa-brands fa-instagram",
  twitter: "fa-brands fa-x-twitter",
  tiktok: "fa-brands fa-tiktok",
  play: "fa-solid fa-play",
  headphones: "fa-solid fa-headphones",
  chart: "fa-solid fa-chart-simple",
  calendar: "fa-solid fa-calendar-days",
  pin: "fa-solid fa-thumbtack",
  eye: "fa-solid fa-eye",
  clock: "fa-solid fa-clock",
  radio: "fa-solid fa-radio",
  coffee: "fa-solid fa-mug-hot",
  cpu: "fa-solid fa-microchip",
  bell: "fa-solid fa-bell",
  envelope: "fa-solid fa-envelope",
};

export default function FaIcon({ name, className = "", style = {}, size }) {
  if (!name) return null;

  // Guard against non-string arguments
  if (typeof name !== "string") {
    if (React.isValidElement(name)) return name;
    if (typeof name === "function") {
      const Component = name;
      return <Component className={className} style={style} />;
    }
    return null;
  }

  // If it's an image URL or path
  if (name.startsWith("http://") || name.startsWith("https://") || name.startsWith("/") || name.includes(".")) {
    return (
      <img
        src={name}
        alt="icon"
        className={`object-contain inline-block ${className}`}
        style={{ width: size || 16, height: size || 16, ...style }}
      />
    );
  }

  const raw = name.trim();
  const lower = raw.toLowerCase();

  // If it already has fa- or fas or fab or far
  let iconClass = raw;
  if (!raw.includes("fa-") && !raw.includes("fas ") && !raw.includes("fab ") && !raw.includes("far ")) {
    iconClass = ICON_ALIAS_MAP[lower] || `fa-solid fa-${lower}`;
  } else if (!raw.includes("fa-solid") && !raw.includes("fa-brands") && !raw.includes("fa-regular") && raw.startsWith("fa-")) {
    iconClass = `fa-solid ${raw}`;
  }

  return (
    <i
      className={`${iconClass} ${className}`}
      style={{
        fontSize: size ? (typeof size === "number" ? `${size}px` : size) : undefined,
        ...style,
      }}
      aria-hidden="true"
    />
  );
}
